<app-tabla
  [totalCount]="totalCount"
  [datos]="despachos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [crear]="botonCrear"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay despachos' }"
></app-tabla>
